import Vue from 'vue'
import { isPlainObject } from 'lodash'

const runtimeProviders = Vue.observable({
  companyConfiguration: {
    consolidatedSettings: {
      COMPANY_PROFILE_ENABLED: true,
      DASHBOARD_ENABLED: true,
      JIRA_CHAT_ENABLED: true,
      MARKETPLACE_PROFILE_ENABLED: true,
      PAYS_BILL: true,
      PRICING_VISIBLE: true,
      PRODUCT_TYPE_IX: false,
      PRODUCT_TYPE_MCR2: false,
      PRODUCT_TYPE_MVE: false,
      PRODUCT_TYPE_PORT: false,
      PRODUCT_TYPE_VXC: false,
      RECEIVES_NOTIFICATIONS: false,
      REGISTRATION_TYPE_EMAIL_LINK: false,
      REGISTRATION_TYPE_USER_PROVIDES_CREDENTIALS: false,
    },
  },
})

/**
 * Updates the runtime provider with the given company feature settings
 * @param {*} data The company feature settings
 * @returns {void}
 */
export function updateRuntime(data) {
  const companyFeatureSettings = data?.companyConfiguration?.consolidatedSettings || []

  companyFeatureSettings.forEach(({ key, value }) => {
    updateRuntimeFeatureFlag(['companyConfiguration', 'consolidatedSettings', key], value)
  })
}

/**
 * Updates the runtime provider with a given path and value
 * @param {Array} path Array of keys representing the path to the feature flag
 * @param {Boolean|String} value The value to set the feature flag to
 * @returns {void}
 */
export function updateRuntimeFeatureFlag(path, value) {
  function nestedUpdate(obj, keys) {
    const [firstKey, ...remainingKeys] = keys

    // If we're at the end of the path, set the value.
    if (remainingKeys.length === 0) {
      obj[firstKey] = value
      return
    }

    // In the presence of nested objects, recurse.
    if (isPlainObject(obj[firstKey])) {
      nestedUpdate(obj[firstKey], remainingKeys)
    }
  }

  nestedUpdate(runtimeProviders, path)
}

/**
 * Checks if the runtime feature flag is enabled
 * @param {String} key The name of the feature flag
 * @returns {Boolean} A boolean indicating if the feature flag is enabled
 */
export function isFeatureEnabled(key) {
  return !!runtimeProviders.companyConfiguration.consolidatedSettings?.[key]
}

export default { ...runtimeProviders, updateRuntime, updateRuntimeFeatureFlag, isFeatureEnabled }
